/**
 * Shared SVG attribute constants for flat silhouettes.
 *
 * Colours are CSS custom properties with literal fallbacks so the same
 * string renders themed in the app and standalone in the PDF.
 */

export const OUTLINE = "var(--flat-outline, #334155)";
export const STITCH = "var(--flat-stitch, #94a3b8)";
export const FILL = "var(--flat-fill, #ffffff)";

export const OUTLINE_ATTRS = `stroke="${OUTLINE}" stroke-width="2.25" fill="${FILL}" stroke-linejoin="round" stroke-linecap="round"`;
export const DETAIL_ATTRS = `stroke="${OUTLINE}" stroke-width="1.3" fill="none" stroke-linejoin="round" stroke-linecap="round"`;
export const DETAIL_FILLED_ATTRS = `stroke="${OUTLINE}" stroke-width="1.3" fill="${FILL}" stroke-linejoin="round" stroke-linecap="round"`;
export const STITCH_ATTRS = `stroke="${STITCH}" stroke-width="1.2" stroke-dasharray="5 4" fill="none" stroke-linecap="round"`;
